import { render, staticRenderFns } from "./TipoServicosCadastro.vue?vue&type=template&id=025f563b&scoped=true&"
import script from "./TipoServicosCadastro.vue?vue&type=script&lang=js&"
export * from "./TipoServicosCadastro.vue?vue&type=script&lang=js&"
import style0 from "./TipoServicosCadastro.vue?vue&type=style&index=0&id=025f563b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025f563b",
  null
  
)

export default component.exports